import { SxProps, Theme } from '@mui/material';

type StyleMap = Record<string, SxProps<Theme>>;

export const styles: StyleMap = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: '#f7f8fb',
    p: { xs: 1.5, sm: 2 },
  },
  card: {
    maxWidth: 420,
    width: '100%',
    p: { xs: 2, sm: 4 },
    borderRadius: { xs: 2, sm: 3 },
  },
  hero: {
    width: '100%',
    height: { xs: 140, sm: 180 },
    objectFit: 'cover',
    borderRadius: { xs: '8px', sm: '12px' },
  },
  logo: {
    width: { xs: 48, sm: 64 },
    height: { xs: 48, sm: 64 },
    objectFit: 'contain',
    borderRadius: 2,
  },
  logoPlaceholder: {
    width: { xs: 48, sm: 64 },
    height: { xs: 48, sm: 64 },
    objectFit: 'contain',
    borderRadius: 2,
    bgcolor: '#e9eef3',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    color: '#394b59',
  },
  centerText: {
    textAlign: 'center',
  },
  headingTitle: {
    typography: { xs: 'h6', sm: 'h6' },
  },
  form: {
    width: '100%',
  },
  inputLabel: {
    fontSize: { xs: 12, sm: 14 },
    lineHeight: 1.2,
  },
  textField: {
    '& .MuiInputBase-input': {
      fontSize: { xs: 14, sm: 16 },
      lineHeight: 1.5,
    },
  },
  submitButton: {
    textTransform: 'none',
    fontWeight: 600,
    height: { xs: 40, sm: 48 },
  },
};
